import React, { useState } from 'react';
import { format, startOfToday } from 'date-fns';
import { CalendarDays } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

// value / onChange use 'yyyy-MM-dd' strings.
export const DateField = ({ value, onChange, testId }) => {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(`${value}T00:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="w-full justify-start font-normal" data-testid={testId}>
          <CalendarDays className="w-4 h-4 mr-2 opacity-60" />
          <span className={value ? '' : 'text-gray-400'}>{date ? format(date, 'dd MMM yyyy') : 'Pick a date'}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-auto" align="start">
        <Calendar mode="single" selected={date} initialFocus disabled={{ before: startOfToday() }}
          onSelect={(d) => { onChange(d ? format(d, 'yyyy-MM-dd') : ''); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
};

export default DateField;
